import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { Link } from 'react-router-dom';

import { Box, Divider, Typography, Grid, Button, Container,
            CircularProgress, Card, CardActions,} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';

function Almacenes() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
      if (!['Admin', 'Almacen'].includes(auth.user.rol)) {
        navigate('/dashboard');
    }
        document.title = 'Almacenes';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get('/api/warehouses');
            setData(res.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setApiRes({ show: true, message: 'Error al obtener los datos', severity: 'error' });
        }
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            {loading ? 
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :
                <>
                    <Box className='text-center' >
                        <Typography variant='h4' style={{ fontWeight: 700 }}>Almacenes</Typography>
                    </Box>
                    <Button size='small' variant='outlined' onClick={() => navigate('/almacenes')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    <Divider variant="middle" className='my-3' />
                    <Grid container spacing={3}>
                        {data.map((alm, i) => {
                            return(
                                <Grid item key={i} xs={12} sm={6} md={4}>
                                    <CustomAlmacenCard
                                        title={alm.almacen}
                                        anaqueles={alm.anaqueles.length}
                                        button='Visualizar almacén'
                                        cardIco='fad fa-boxes fa-3x'
                                        button2='Editar'
                                        id={alm._id}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                    <br></br>
                </>
            }
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </Container>
    );
}

function CustomAlmacenCard(props) {
    return (
      <Box sx={{ minWidth: 240, display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100%' }}>
        <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px', width: '100%', justifyContent: 'end' }} elevation={3}>
          <div>
            <Box className='mb-2' sx={{ color: 'secondary.main' }}>
              <i className={props.cardIco}></i>
            </Box>
          </div>
          <div>
            <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
              {props.title}
            </Typography>
            <Typography variant="body1" className='p-1'>
              Anaqueles: {props.anaqueles}
            </Typography>
            <Typography variant="body1" className='p-1'>
              {props.text}
            </Typography>
          </div>
          <Divider variant="middle" className='my-1' sx={{ width: '100%' }} />
          <div>
            <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
              <Link to={props.to} style={{ textDecoration: 'none' }}>
                <Button color='secondary' variant='outlined'>{props.button} &nbsp; {props.buttonIco ? <i className={props.buttonIco}></i> : <i className="fad fa-arrow-circle-right"></i>}</Button>
              </Link>
              <Link target='_blank' to={{ pathname: '/almacenes/editarAlmacen/' + props.id, state: { id: props.id } }} style={{ textDecoration: 'none' }}>
                <Button color='secondary' variant='outlined'>{props.button2} &nbsp; {props.buttonIco ? <i className={props.buttonIco}></i> : <i className="fad fa-edit"></i>}</Button>
              </Link>
            </CardActions>
          </div>
        </Card>
      </Box>
    );
  }

export default Almacenes;